import { StateRepository } from '@angular-ru/ngxs/decorators';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State, StateToken, Store } from '@ngxs/store';
import { ConfirmationService } from 'primeng/api';
import { filter, first } from 'rxjs/operators';
import {
    IProductCategoryAvailability
} from 'src/app/models/case';
import { ProductAvailability } from 'src/app/models/product';
import { SignalREvent } from 'src/app/models/signalr';
import { TaskOrchestratorService } from 'src/app/services/task-orchestrator/task-orchestrator.service';
import { IDisqualificationReason, IInterviewHandler } from 'src/app/shared/interview-new/models/interview-handler.models';
import { InterviewHandlerService } from 'src/app/shared/interview-new/services/interview-handler.service';
import { FeatureService } from 'src/app/shared/preview-feature/preview-feature.service';
import { BaseProductServiceSingle } from '../-base-product.service-single';
import { CaseService } from '../../case/case.service';
import { interviewSNAPDataProviderToken } from '../../interview-providers/interview-data-provider.tokens';
import { MemberService } from '../../member/member.service';
import { ProductContextService } from '../../product-context/product-context.service';
import { TaskServiceFactory, TaskServiceFactoryFn } from '../../task/task.service';
import { UserService } from '../../user/user.service';
import { MEDICAID_TOKEN_TOKEN, MedicaidStateModel, ProductNameManagedRetention } from '../medicaid/medicaid.state.models';
import { AlertService } from './../../alert.service';
import { SNAPInterviewData } from './snap-interview-data';
import { SNAPStateModel } from './snap.state.models';

export const SNAP_TOKEN_KEY = 'snapState';
export const SNAP_TOKEN_TOKEN = new StateToken<SNAPService>(SNAP_TOKEN_KEY);

@StateRepository()
@State<SNAPStateModel>({
    name: SNAP_TOKEN_TOKEN,
    defaults: {

    }
})
@Injectable()
export class SNAPService extends BaseProductServiceSingle<SNAPStateModel> {

    get stateToken() {
        return SNAP_TOKEN_TOKEN;
    }

    // get status$(): Observable<IProductContextCaseStatus> {
    //     return this.store.select<IProductContextCaseStatus>(SNAPService.status);
    // }

    // get statusSync(): IProductContextCaseStatus {
    //     return this.store.selectSnapshot<IProductContextCaseStatus>(SNAPService.status);
    // }

    // get caseOwner$(): Observable<IProductContextMetadataOwner> {
    //     return this.store.select<IProductContextMetadataOwner>(SNAPService.owner);
    // }

    // get caseOwnerSync(): IProductContextMetadataOwner {
    //     return this.store.selectSnapshot<IProductContextMetadataOwner>(SNAPService.owner);
    // }

    // get sourceProduct$(): Observable<Product> {
    //     return this.store.select<Product>(SNAPService.sourceProduct);
    // }

    // get productCategoryContext$(): Observable<IProductCategoryContext> {
    //     return this.store.select<IProductCategoryContext>(SNAPService.productCategoryContext);
    // }


    // get productCategoryContextSync(): IProductCategoryContext {
    //     return this.store.selectSnapshot<IProductCategoryContext>(SNAPService.productCategoryContext);
    // }

    // get metadataSync(): any {
    //     return this.store.selectSnapshot<IProductContextCase>(SNAPService.metadata);
    // }
    // get metadata$(): Observable<any> {
    //     return this.store.select<any>(SNAPService.metadata);
    // }

    // get currentCaseSync(): IProductContextCase {
    //     return this.store.selectSnapshot<IProductContextCase>(SNAPService.currentCase);
    // }


    // get currentCase$(): Observable<IProductContextCase> {
    //     return this.store.select<IProductContextCase>(SNAPService.currentCase);
    // }

    // get caseStageSync(): IProductStage {
    //     return this.store.selectSnapshot<IProductStage>(SNAPService.caseStage);
    // }
    // get caseStage$(): Observable<IProductStage> {
    //     return this.store.select<IProductStage>(SNAPService.caseStage);
    // }

    // get notifications$(): Observable<INotification[]> {
    //     return this.store.select<INotification[]>(SNAPService.notifications);
    // }

    // get productInterviewsSync(): IProductInterviewConfig[] {
    //     return this.store.selectSnapshot<IProductInterviewConfig[]>(SNAPService.productInterviews);
    // }

    // get productInterviews$(): Observable<IProductInterviewConfig[]> {
    //     return this.store.select<IProductInterviewConfig[]>(SNAPService.productInterviews);
    // }

    // get caseAssessmentSync(): IProductContextAssessmentStatus {
    //     return this.store.selectSnapshot<IProductContextAssessmentStatus>(SNAPService.caseAssessment);
    // }
    // get caseAssessment$(): Observable<IProductContextAssessmentStatus> {
    //     return this.store.select<IProductContextAssessmentStatus>(SNAPService.caseAssessment);
    // }


    // get iconSync(): string {
    //     return this.store.selectSnapshot<string>(SNAPService.icon);
    // }
    // get icon$(): Observable<string> {
    //     return this.store.select<string>(SNAPService.icon);
    // }

    // get noCaseMessageSync(): string {
    //     return this.store.selectSnapshot<string>(SNAPService.noCaseMessage);
    // }
    // get noCaseMessage$(): Observable<string> {
    //     return this.store.select<string>(SNAPService.noCaseMessage);
    // }

    // get categoryDisplayNameSync(): string {
    //     return this.store.selectSnapshot<string>(SNAPService.categoryDisplayName);
    // }
    // get categoryDisplayName$(): Observable<string> {
    //     return this.store.select<string>(SNAPService.categoryDisplayName);
    // }

    // get stagesSync(): IProductStage[] {
    //     return this.store.selectSnapshot<IProductStage[]>(SNAPService.stages);
    // }
    // get stages$(): Observable<IProductStage[]> {
    //     return this.store.select<IProductStage[]>(SNAPService.stages);
    // }

    // get smartActionsSync(): IProductSmartActionReference[] {
    //     return this.store.selectSnapshot<IProductSmartActionReference[]>(SNAPService.smartActions);
    // }
    // get smartActions$(): Observable<IProductSmartActionReference[]> {
    //     return this.store.select<IProductSmartActionReference[]>(SNAPService.smartActions);
    // }


    get interviewDataProviderToken() {
        return interviewSNAPDataProviderToken;
    }


    constructor(
        memberService: MemberService,
        userService: UserService,
        confirmationService: ConfirmationService,
        caseService: CaseService,
        productContextService: ProductContextService,
        router: Router,
        route: ActivatedRoute,
        alertService: AlertService,
        store: Store,
        featureService: FeatureService,
        taskOrchestratorService: TaskOrchestratorService,
        @Inject(TaskServiceFactory) taskService: TaskServiceFactoryFn
    ) {
        super(
            'SNAP',
            memberService,
            userService,
            caseService,
            productContextService,
            confirmationService,
            router,
            route,
            alertService,
            SNAPInterviewData,
            store,
            featureService,
            new InterviewHandlerService(),
            taskOrchestratorService
        );

        this.taskService = taskService().setContext();
        this.taskService.activate();
    }


    signalRFilter(event: SignalREvent): boolean {
        return true;
    }

    async customizeAvailability(avail: IProductCategoryAvailability): Promise<IProductCategoryAvailability> {
        const medicaidState = await this.store.select<MedicaidStateModel>(MEDICAID_TOKEN_TOKEN).pipe(filter(_ => !!_), first()).toPromise();

        if (medicaidState.sourceProduct && medicaidState.sourceProduct.name.toUpperCase() === ProductNameManagedRetention) {
            return { available: false, availabilityReason: ProductAvailability.Disabled, stageDisplayName: 'Disallowed for Managed Medicaid' } as IProductCategoryAvailability;
        }

        return avail;
    }

    async canInterviewAdvanceStage(status: string, disqualificationReason: IDisqualificationReason, interviewHandler: IInterviewHandler) {
        const result = (disqualificationReason != null || 'Eligibility' === this.caseStageSync.name);
        return result;
    }

}
